module.exports = __webpack_public_path__ + "assets/img/v_for.2a07e55b.jpg";